module.exports = __webpack_public_path__ + "static/media/lineto-akkuratmono-pro-regular-ca30f67bf68b4d022686179b109b3367.ca30f67b.woff";